import { useState, useEffect } from "react";
import { Spin } from "antd";
import { Outlet } from "react-router-dom";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import { updateUser } from "scripts/reducer";
import API from "scripts/api";

import AroundModal from "modals/around";
import CategoryModal from "modals/category";
import LocationModal from "modals/location";
import SortModal from "modals/sort";
import PWAHeader from "components/header/pwa";
import SPAFooter from "components/footer/spa";
import SPAHeader from "components/header/spa";

const Component = ({ onUpdateUser }) => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { loaded } = state;

	const componentDidMount = () => {
		const token = API.getCookie(process.env.REACT_APP_COOKIE_TOKEN);

		if (token) {
			API.auth
				.me()
				.then((user) => {
					onUpdateUser(user);
				})
				.finally(() => {
					setState((prevState) => ({
						...prevState,
						loaded: true,
					}));
				});
		} else {
			setState((prevState) => ({
				...prevState,
				loaded: true,
			}));
		}
	};

	useEffect(componentDidMount, []);

	return loaded ? (
		<>
			<MediaQuery minWidth={992}>
				<SPAHeader />
			</MediaQuery>
			<MediaQuery maxWidth={992}>
				<PWAHeader />
			</MediaQuery>
			<Outlet />
			<MediaQuery minWidth={992}>
				<SPAFooter />
			</MediaQuery>
			<AroundModal />
			<CategoryModal />
			<LocationModal />
			<SortModal />
		</>
	) : (
		<Spin className="page-loading" />
	);
};

export default connect(
	(state) => {
		return {};
	},
	(dispatch) => {
		return {
			onUpdateUser: (data) => dispatch(updateUser(data)),
		};
	}
)(Component);
